/**
 * Local-first downloads list for guest users. Persists to localStorage
 * under `vaad_downloads_v1` so favorites & downloads survive page reloads
 * on the same device even if the user never signs in with Google.
 *
 * Each entry is `{ recording, downloaded_at }` — matching the shape the
 * authenticated /api/downloads endpoint returns, so DownloadsPage and
 * MyDownloadsPage can render either source through the same component.
 */
const KEY = 'vaad_downloads_v1';
const EVENT = 'vaad:downloads-changed';

const _read = () => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

const _write = (list) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(list));
    window.dispatchEvent(new CustomEvent(EVENT));
  } catch {
    /* quota exceeded — silently ignore, next login will pick it up */
  }
};

export const listLocalDownloads = () => _read();

export const trackLocalDownload = (recording) => {
  if (!recording?.drive_file_id) return;
  const list = _read();
  const idx = list.findIndex((d) => d.recording?.drive_file_id === recording.drive_file_id);
  const entry = { recording, downloaded_at: new Date().toISOString() };
  if (idx >= 0) list.splice(idx, 1);
  list.unshift(entry);
  // Cap at 500 to keep the payload sane if a user hammers "Download all".
  _write(list.slice(0, 500));
};

export const removeLocalDownload = (driveFileId) => {
  const list = _read().filter((d) => d.recording?.drive_file_id !== driveFileId);
  _write(list);
};

export const clearLocalDownloads = () => _write([]);

export const downloadsChangeEvent = EVENT;
